var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6666 4.69261C29.3898 5.59324 27.9761 6.28209 26.4799 6.73261C25.6769 5.80929 24.6097 5.15486 23.4226 4.85784C22.2356 4.56082 20.9859 4.63553 19.8427 5.07188C18.6995 5.50822 17.7178 6.28514 17.0306 7.29756C16.3433 8.30998 15.9835 9.50906 15.9999 10.7326V12.0659C13.6568 12.1267 11.335 11.607 9.24126 10.5532C7.14758 9.49938 5.34701 7.94412 3.99992 6.02594C3.99992 6.02594 -1.33341 18.0259 10.6666 23.3593C7.92062 25.2232 4.64946 26.1578 1.33325 26.0259C13.3333 32.6926 27.9999 26.0259 27.9999 10.6926C27.9987 10.3212 27.963 9.95073 27.8933 9.58594C29.2541 8.24393 30.2144 6.54956 30.6666 4.69261Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.bcbf96636cd02accab53c89e59d67c63.svg";
export { ForwardRef as ReactComponent };